import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'for',
    colour: CATEGORIES.control.color,
    tooltip: '指定した回数だけ繰り返します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('FOR', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'COUNT',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 9 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: '回くりかえす ' }],
        },
        {
            kind: 'statement',
            name: 'DO',
        },
    ],
});
